import React from 'react'
import styled from '@emotion/styled'
import { Icon, IconType } from '@mobi/component-library/Legacy/Icon'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { colors, font, spacing } from '@mobi/component-library/Foundations'
import { CountdownBadge } from '@mobi/component-library/Feedback/CountdownBadge'
import type { RaceCodes } from '@core/Areas/Racing/Types/MeetingInformation'

interface Props {
  locationName: string
  raceNumber?: number
  code?: RaceCodes
  advertisedStartTime: string
}

export const StructuredLocationTime: React.FC<Props> = ({
  locationName,
  raceNumber,
  code,
  advertisedStartTime,
}) => {
  const codeIcon = code ? IconTypes[code] : undefined

  return (
    <Flex alignItems='center' gap={spacing.smx1}>
      <CountdownBadge advertisedStartTime={new Date(advertisedStartTime)} badgeSize='S' />

      <LocationNameStyled data-tid-search-location={locationName}>
        <span>{locationName}</span>

        {raceNumber && <span>{`R${raceNumber}`}</span>}

        {codeIcon && <Icon type={codeIcon} size='2.2rem' />}
      </LocationNameStyled>
    </Flex>
  )
}

// =============
// Local Helpers
// =============

const IconTypes: Record<string, IconType> = {
  Races: 'races',
  Trots: 'trot',
  Dogs: 'dog',
}

// ======
// Styles
// ======

const LocationNameStyled = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  gap: spacing.smx2,
  marginLeft: 'auto',
  fontSize: font.size.md.fontSize,
  letterSpacing: font.size.md.letterSpacing,
  lineHeight: font.size.md.lineHeight,
  fontWeight: font.weight.regular,
  color: colors.neutral[800],

  '@media (max-width: 350px)': {
    maxWidth: '20rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
})
